import router from '@/router'
import { isMobile } from '@/utils'
export const authDirective = {
  beforeMount(el: any, binding: any) {
    const domain = el.getAttribute('attr-domain')
    const handleClick = (event: any) => {
      const userStore = useUserStore()
      const { isLogin } = storeToRefs(userStore)
      Session.set('redirectUri', window.location.href)
      if (isLogin.value) {
        binding.value?.clickHandler(event)
      } else {
        GlobalThis.$loginModalNew.openModal(domain)
        // if (isMobile()) {
        //   let query = {}
        //   if (['Creators', 'Post'].includes(router.currentRoute.value.name)) {
        //     query = {
        //       domain: domain || router?.currentRoute?.value?.params?.domain,
        //     }
        //   }
        //   router.push({ name: 'LoginPhone', query })
        // } else {
        //   GlobalThis.$loginModalNew.openModal(domain)
        // }
        GlobalThis.$buyModal.close()
      }
    }
    const wrappedHandler = () => {
      handleClick(binding.value?.args)
    }

    el.addEventListener('click', wrappedHandler)

    // 确保在组件卸载时移除事件监听器，以防止内存泄漏
    el._authDirectiveCleanup = () => {
      el.removeEventListener('click', wrappedHandler)
    }
  },
  unmounted(el: any) {
    // 在指令所在元素被销毁时，移除事件监听器
    el._authDirectiveCleanup && el._authDirectiveCleanup()
  },
}
